"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthRelativeValueImpressions = exports.healthProfitImpressions = exports.healthMomentumImpressons = exports.healthGrowthImpressions = exports.healthCashFlowImpressions = void 0;
const hi_1 = require("react-icons/hi");
const React = require("react");
const gi_1 = require("react-icons/gi");
const general_impression_config_1 = require("../config/general-impression.config");
const md_1 = require("react-icons/md");
const bi_1 = require("react-icons/bi");
exports.healthCashFlowImpressions = {
    success: {
        title: 'Saúde de caixa.',
        subtitle: 'Muito boa',
        importantLevel: 90,
        description: 'Ao analisar diversas métricas avançadas, foi possível destacar que a saúde do caixa está com um bom desempenho atualmente.',
        icon: React.createElement(hi_1.HiOutlineCash, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        id: 0,
        reportableIdentification: 'BOA_SAUDE_CAIXA',
    },
    danger: {
        title: 'Fluxo de caixa.',
        subtitle: 'PROBLEMÁTICO',
        importantLevel: 90,
        description: 'Ao analisar diversas métricas avançadas, foi possível destacar que a saúde de caixa está com um baixo desempenho atualmente.',
        icon: React.createElement(md_1.MdMoneyOffCsred, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        id: 1,
        reportableIdentification: 'RUIM_SAUDE_CAIXA',
    },
};
exports.healthGrowthImpressions = {
    success: {
        title: 'Alto',
        subtitle: 'Crescimento',
        importantLevel: 90,
        description: 'Ao analisar dados operacionais e contábeis da empresa, foi possível determinar que a mesma está com um excelente nível de crescimento.',
        icon: React.createElement(bi_1.BiExpandAlt, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        id: 0,
        reportableIdentification: 'BOM_CRESCIMENTO',
    },
    danger: {
        title: 'Baixo',
        subtitle: 'Crescimento',
        importantLevel: 90,
        description: 'Ao analisar dados operacionais e contábeis da empresa, foi possível determinar que a mesma está com um baixo nível de crescimento.',
        icon: React.createElement(bi_1.BiExpandAlt, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        id: 1,
        reportableIdentification: 'BAIXO_CRESCIMENTO',
    },
};
exports.healthMomentumImpressons = {
    success: {
        title: 'Bons',
        subtitle: 'Retornos',
        importantLevel: 90,
        description: 'Ao analisar os retornos sobre preço, foi possível determinar que o ativo oferece bons retornos financeiros para os investidores com o passar do tempo.',
        icon: React.createElement(gi_1.GiSandsOfTime, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        id: 0,
        reportableIdentification: 'BOM_RETORNO',
    },
    danger: {
        title: 'Baixos',
        subtitle: 'Retornos',
        importantLevel: 90,
        description: 'Ao analisar os retornos sobre preço, foi possível determinar que o ativo oferece baixos retornos financeiros para os investidores com o passar do tempo.',
        icon: React.createElement(gi_1.GiSandsOfTime, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        id: 1,
        reportableIdentification: 'BAIXO_RETORNO',
    },
};
exports.healthProfitImpressions = {
    success: {
        title: 'Lucro',
        subtitle: 'Saudável',
        importantLevel: 90,
        description: 'Foi detectado que a empresa está com uma boa saúde de lucro em suas operações.',
        icon: React.createElement(gi_1.GiProfit, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        id: 0,
        reportableIdentification: 'BOA_SAUDE_LUCRO',
    },
    danger: {
        title: 'Lucro',
        subtitle: 'Problemático',
        importantLevel: 90,
        description: 'Foi detectado que a empresa está com uma baixa saúde de lucro em suas operações.',
        icon: React.createElement(gi_1.GiProfit, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        id: 1,
        reportableIdentification: 'BAIXA_SAUDE_LUCRO',
    },
};
exports.healthRelativeValueImpressions = {
    success: {
        title: 'Forte',
        subtitle: 'Concorrente',
        importantLevel: 90,
        description: 'A empresa é uma forte concorrente em seu setor de atuação e se mantém competitiva no mercado mesmo com o passar do tempo.',
        icon: React.createElement(gi_1.GiArrowsShield, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        id: 0,
        reportableIdentification: 'FORTE_CONCORRENTE',
    },
    danger: {
        title: 'Sofrendo',
        subtitle: 'Com a concorrencia',
        importantLevel: 90,
        description: 'Outras empresas concorrentes do mesmo setor de atuação tem conseguido apresentar melhores resultados com o passar do tempo.',
        icon: React.createElement(gi_1.GiArrowed, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        id: 1,
        reportableIdentification: 'FRACO_CONCORRENTE',
    },
};
//# sourceMappingURL=health-impressions.data.js.map